const searchStrip = {
};

export default searchStrip;
